"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "VictoryPolarAxis", {
  enumerable: true,
  get: function () {
    return _victoryPolarAxis.default;
  }
});

var _victoryPolarAxis = _interopRequireDefault(require("./victory-polar-axis"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/victory-polar-axis/lib/index.js
// module id = 686
// module chunks = 0